import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import { baseProductFilteringParams } from '@telialt/core-eshop/src/constants';
import { ESHOP_QUERY_KEY } from '@telialt/core-eshop/src/model';
import { apiGetBaseProductFromUrlParam, Params } from '@telialt/core-eshop/src/store/api';
import { useSegment } from '@telialt/utils/src/segment';

import { ProductPagePathParams } from '../models';

export const useBaseProductFromUrlParam = (params?: Params) => {
    const { pathParams } = useParams<ProductPagePathParams>();
    const baseProductCodeUrlParam = pathParams[pathParams.length - 1];
    const segment = useSegment();

    const {
        data: baseProduct,
        isLoading,
        error,
    } = useQuery({
        queryKey: [ESHOP_QUERY_KEY.BASE_PRODUCT],
        queryFn: async () =>
            (
                await apiGetBaseProductFromUrlParam(segment, baseProductCodeUrlParam, {
                    ...baseProductFilteringParams,
                    ...params,
                })
            ).data,
    });

    return {
        baseProduct,
        baseProductIsLoading: isLoading,
        baseProductError: error,
        baseProductCodeUrlParam,
    };
};
